interface StateType {
    zhUserInfo: object;
    jjUserInfo: object;
}

export default {
    state: {
        zhUserInfo: {},
        jjUserInfo: {}
    },
    getters: {
        zhUserInfo(state: StateType): object {
            return state.zhUserInfo;
        },
        jjUserInfo(state: StateType): object {
            return state.jjUserInfo;
        }
    },
    mutations: {
        setZhUserInfo(state: StateType, playLoad: object) {
            state.zhUserInfo = playLoad;
        },
        setjjUserInfo(state: StateType, playLoad: object) {
            state.jjUserInfo = playLoad;
        }
    },
    namespaced: true
};
